import { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

const KEY = "tlp-consent";

const CookieConsent = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => {
    try {
      return !localStorage.getItem(KEY);
    } catch {
      return false;
    }
  });

  if (!visible) return null;

  const accept = () => {
    try {
      localStorage.setItem(KEY, "accepted");
    } catch {
      // storage unavailable; hide for this session only
    }
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-consent"
      className="fixed inset-x-0 bottom-[72px] z-[105] border-t border-white/10 bg-void/90 backdrop-blur-xl md:bottom-0"
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-center gap-2 px-4 py-2.5 text-center sm:flex-row sm:gap-4">
        <p className="text-sm font-light text-fog">
          {t("cookie.text", "This site uses essential cookies and privacy-respecting analytics. By continuing, you acknowledge our")}{" "}
          <Link to="/privacy" data-testid="cookie-privacy-link" className="link-underline text-white">
            {t("footer.privacy", "Privacy Policy")}
          </Link>
          .
        </p>
        <button
          type="button"
          onClick={accept}
          data-testid="cookie-accept-button"
          className="bg-gradient-accent shrink-0 rounded-full px-5 py-1.5 text-sm font-semibold text-white transition-opacity duration-300 hover:opacity-90"
        >
          {t("cookie.accept", "Got it")}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
